import { render, staticRenderFns } from "./NotificationABM.vue?vue&type=template&id=31215ba8&scoped=true"
import script from "./NotificationABM.vue?vue&type=script&lang=js"
export * from "./NotificationABM.vue?vue&type=script&lang=js"
import style0 from "./NotificationABM.vue?vue&type=style&index=0&id=31215ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31215ba8",
  null
  
)

export default component.exports